// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-root-89q {\n}\n\n.category-title-J65 {\n}\n\n.category-pagination-W3D {\n}\n\n.category-placeholder-eiC {\n}\n\n.category-categoryTitle-hxg {\n}\n\n.category-heading-cBC {\n}\n\n.category-categoryContent-yd9 {\n}\n\n.category-categoryInfo-WW8 {\n    flex-basis: 100%;\n}\n\n.category-headerButtons-ZNv {\n    flex-basis: 100%;\n}\n\n.category-contentWrapper-2W7 {\n}\n\n.category-sidebar-HXv {\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "category-root-89q p-xs",
	"title": "category-title-J65 font-normal px-2xs py-0 text-xl",
	"pagination": "category-pagination-W3D relative bottom-0",
	"placeholder": "category-placeholder-eiC h-screen",
	"categoryTitle": "category-categoryTitle-hxg font-light leading-snug pb-xs text-colorDefault text-center text-xl",
	"heading": "category-heading-cBC flex flex-wrap justify-center pb-2xs lg_flex-nowrap lg_items-center lg_justify-between lg_pb-sm lg_w-full",
	"categoryContent": "category-categoryContent-yd9 lg_flex-grow",
	"categoryInfo": "category-categoryInfo-WW8 leading-tight max-w-[75vw] mx-0 my-xs text-center lg_m-0 lg_text-left",
	"headerButtons": "category-headerButtons-ZNv flex justify-center pb-sm lg_justify-end lg_pb-0",
	"contentWrapper": "category-contentWrapper-2W7 w-full lg_flex",
	"sidebar": "category-sidebar-HXv hidden lg_flex lg_self-start lg_pt-16 lg_w-filterSidebarWidth"
};
export default ___CSS_LOADER_EXPORT___;
